import { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from 'firebase/database';
import { getAuth } from "firebase/auth";
import { Notification } from "./modals";
import { openlightbox } from "../util/Functions";
import { Box, Divider, Toolbar, Typography, Avatar, IconButton, AppBar, Badge } from '@mui/material';
import { Notifications, Menu, Search } from "@mui/icons-material";
import { ThemeProvider, styled, alpha  } from '@mui/material/styles';
import { theme } from "../util/TableStyles";
import LogoIndigo from '../images/indigo_logo.svg';

const SearchWrapper = styled('div')(({ theme }) => ({
	position: 'relative',
	borderRadius: theme.shape.borderRadius,
	backgroundColor: alpha(theme.palette.common.white, 0.15),
	'&:hover': {
		backgroundColor: alpha(theme.palette.common.white, 0.25),
	}
}));

const Bar = (props) => {
	const [total, setTotal] = useState(0);
	const [notifications, setNotifications] = useState([]);

	let info = localStorage.session ? JSON.parse(localStorage.session) : {};

	useEffect(() => {
		init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const init = async () => {
		if(info.uuid){
			await getNotifications(info.uuid);
		}
	}

	const getNotifications = async (uuid) => {
		let nots = [];
		let shows = [];
		const db = await getDatabase();
        await getAuth();
		let reference = await ref(db, `notificacion/${uuid}`)
		await onValue(reference, (snap) => {
			nots = [];
			shows = [];
			let data = snap.val();
			if(data){
				let key = Object.keys(data);
				for(let i = 0; i<key.length; i++){
					let n = data[key[i]];
					n['id'] = key[i];
					if(n['active']){
						nots.push(n);
						if(shows.length < 3){
							shows.push(n);
						}
					}
				}

			}
			setNotifications(JSON.parse(JSON.stringify(nots)));
			setTotal(nots.length);
		}, (error) => {
			console.log(error);
		});
		return nots;
	}

	const openNotif = async (e) => {
		await init()
		const as = <Notification
			pos={props.pos}
			key={'notifications'}
			data={notifications}
			changeLoader={props.changeLoader}
			changeAlert={props.changeAlert}
		/>

		openlightbox(as);
	};

	const handleSearchClick = () => {
		props.mainMenu();
	};

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Escape' && props.openMainMenu) {
				props.mainMenu();
			}
		};
		document.addEventListener('keydown', handleKeyDown);
		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [props]);


	// #0078a7

	return (
		<>
			<ThemeProvider theme={theme} >
			<AppBar position="fixed" sx={{ background: "linear-gradient(to right, #FFFDE4, #3743aa)", paddingBlock: '0.5rem', zIndex: 5 }}>
				<Toolbar sx={{ display: 'flex', justifyContent: 'space-between', px: "2.5rem !important" }}>
					{ props.secondaryMenu.length > 0 &&
						<IconButton onClick={props.openMenu.bind(this)} edge="start"  sx={{mr: '0.8rem'}}>
							<Menu sx={{fontSize: '21px', fontWeight: 900}}/>
						</IconButton>
					}
					<Box sx={{ flexGrow: 1}}>
						<Box component="img" alt="LogoIndigo" src={LogoIndigo} width={"160px"} sx={{verticalAlign: "middle"}}/>
						{props.rolName && props.openMainMenu && <Typography variant="subtitle1" sx={{ marginRight: '1rem', color: theme.palette.common.black }} fontSize={"12px"}>{props.rolName} - <b>albo</b></Typography>}
					</Box>

					{props.rolName && !props.openMainMenu && <Typography variant="subtitle1" sx={{ marginRight: '1rem', color: theme.palette.common.black }} fontSize={"16px"}>{props.rolName} - <b>albo</b></Typography>}

					<Box sx={{ position: 'relative' }} mr={2}>
						<SearchWrapper sx={{
								display: 'flex', alignItems: 'center', width: props.openMainMenu ? '700px' : '40px', transition: 'width 0.3s ease-in-out',
								overflow: 'hidden',	borderRadius: '5px',
							}}
						>
							{!props.openMainMenu && <Search onClick={handleSearchClick} sx={{ cursor: 'pointer', margin: '5px 10px' }} className="text-gray-500 cursor-pointer" />}
						</SearchWrapper>
					</Box>

					<IconButton onClick={openNotif.bind(this)} sx={{color: theme.palette.common.white}}>
						<Badge badgeContent={total} color="error"><Notifications /></Badge>
					</IconButton>
					<Divider orientation="vertical" sx={{pb: 5, ml: 1, backgroundColor: theme.palette.common.white}}/>
					<Box onClick={props.openSideBar.bind(this)} sx={{ display: 'flex', alignItems: 'center', marginLeft: '1rem', cursor: "pointer" }}>
						<Avatar alt={info["avatar"] ? `url(${info["avatar"]})` : info["name"] && info["name"][0]} src={`${info["avatar"]}`} sx={{ bgcolor: theme.palette.common.white, color: theme.palette.info.main, marginRight: '0.5rem' }}/>
						<Typography variant="subtitle1" color={theme.palette.common.white} >
							¡Hola, {info && info["name"]?.split(" ")[0]}!
						</Typography>
					</Box>
				</Toolbar>
				</AppBar>
			</ThemeProvider>
		</>
	)
};

export default Bar;
